import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import styles from './TemplateMsg.module.css'
import { Dropdown, Tabs, Tab } from 'react-bootstrap';
import TemplateMsgItem from './TemplateMsgItem';
import i18next from "i18next";

const TemplateMsg = (props) => {
    const [templateSearchInputState, setTemplateSearchInputState] = useState('')

    const [t] = useTranslation('common')
    const { tempMsgs, templateMessageClickHandler, isLimitedOnlyForWhatsapp, filterCondition } = props
    const drop = props.drop || 'right' //up, right, left
    const whatsappVerifiedTempList = []
    const regularTempMsgList = []
    const lang = i18next.language

    if (tempMsgs?.length > 0) {
        tempMsgs.forEach((tempMsg) => {
            const isMatch = tempMsg.msg.includes(templateSearchInputState);
            const shouldDisplay = filterCondition === 'display' ? tempMsg.display : tempMsg.supportMailingList;

            if (!shouldDisplay || !isMatch) return;
            // if (!tempMsg.display || !tempMsg.msg.includes(templateSearchInputState)) return
            if (tempMsg.whatsappVerified) {
                whatsappVerifiedTempList.push(<TemplateMsgItem tempMsg={tempMsg} templateMessageClickHandler={templateMessageClickHandler} />)
            }
            else {
                regularTempMsgList.push(<TemplateMsgItem tempMsg={tempMsg} templateMessageClickHandler={templateMessageClickHandler} />)
            }
        })
    }

    const menuHeight = filterCondition === 'display' ? styles.tempMsgsMenuDisplay : styles.tempMsgsMenuMailingList;

    return <Dropdown drop={drop}>{/*drop='right'*/}
        {props.children}
        <Dropdown.Menu className={`${styles['tempMsgsMenu']} ${menuHeight}`}>
            <div className={`${styles['templates-search-container']}`}>
                <input type='text' value={templateSearchInputState} onChange={e => setTemplateSearchInputState(e.target.value)} className={`${styles[`template-search-text-input`]} ${lang === 'en' && 'ltr'}`} placeholder={t('search')} />
            </div>
            <Tabs
                transition={false}
                id="controlled-tab-example"
                className='cusTabs'
            >
                {!isLimitedOnlyForWhatsapp &&
                    <Tab className='cusTab' eventKey="RegularMsgs" title={t('Regular messages')}>
                        {regularTempMsgList}
                    </Tab>
                }
                <Tab className='cusTab' eventKey="WhatsappVerified" title={t('Approved by WhatsApp')}>
                    {whatsappVerifiedTempList}
                </Tab>

            </Tabs>
        </Dropdown.Menu>
    </Dropdown>
}

export default TemplateMsg